import ReportDetail from './report-detail';

export default ReportDetail;
